export default "__VITE_ASSET__Daagphnb__"